import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabaseClient";
import SelectDropdown from "@/components/matching-intergenerationnel/SelectDropdown";
import AccessList from "@/components/matching-intergenerationnel/AccessList";
import { motion } from "framer-motion";
import { Access } from "@/types/matching";

interface Beneficiary {
  id: string;
  name: string;
  relation: string;
}



export default function SendAccessPage() {
  const [beneficiaries, setBeneficiaries] = useState<Beneficiary[]>([]);
  const [accesses, setAccesses] = useState<Access[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAll();
  }, []);

  const fetchAll = async () => {
    setLoading(true);
    const { data: b } = await supabase.from("beneficiaries").select("id, name, relation");
    setBeneficiaries(b || []);

    const { data: a } = await supabase
      .from("beneficiaries_access")
      .select("id, access_token, expires_at, beneficiaries(name, email)")
      .gt("expires_at", new Date().toISOString());

    if (a) {
      const mapped: Access[] = a
  .filter((row: any) => row.beneficiaries !== null) // 👈 évite les null
  .map((row: any) => ({
    id: row.id,
    name: row.beneficiaries.name,
    email: row.beneficiaries.email,
    access_token: row.access_token,
    expires_at: row.expires_at,
  }));


      setAccesses(mapped);
    }
    setLoading(false);
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-4xl font-extrabold text-center mb-10 text-gray-800"
      >
        Envoyer un accès aux héritiers
      </motion.h1>

      {loading ? (
        <div className="flex justify-center items-center text-gray-500 mt-12">Chargement en cours...</div>
      ) : (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="bg-white/60 backdrop-blur-md p-8 rounded-2xl shadow-md"
          >
            {beneficiaries.length > 0 ? (
              <SelectDropdown beneficiaries={beneficiaries} onAccessCreated={fetchAll} />
            ) : (
              <div className="text-center py-20">
                <p className="text-gray-400">Aucun héritier disponible pour le moment.</p>
              </div>
            )}
          </motion.div>

          <AccessList accesses={accesses} />
        </>
      )}
    </div>
  );
}
